import type { JSX } from "react";
import type { DailyUsageRow } from "../../../tauri/billing";
import { fmtCost, fmtInt } from "./format";

export function DailyTable({ rows }: { readonly rows: readonly DailyUsageRow[] }): JSX.Element {
  if (rows.length === 0) {
    return <div className="p-4 text-sm text-content-tertiary">No usage recorded yet.</div>;
  }
  return (
    <div className="overflow-x-auto">
      <table className="w-full text-xs">
        <thead>
          <tr className="text-content-tertiary border-b border-edge">
            <th className="text-left font-medium px-3 py-2">Day</th>
            <th className="text-left font-medium px-3 py-2">Provider</th>
            <th className="text-left font-medium px-3 py-2">Model</th>
            <th className="text-right font-medium px-3 py-2">Input</th>
            <th className="text-right font-medium px-3 py-2">Output</th>
            <th className="text-right font-medium px-3 py-2">Cache R</th>
            <th className="text-right font-medium px-3 py-2">Cache W</th>
            <th className="text-right font-medium px-3 py-2">Calls</th>
            <th className="text-right font-medium px-3 py-2">Cost</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((r) => (
            <tr
              key={`${r.day}:${r.provider}:${r.model}`}
              className="border-b border-edge/50 last:border-b-0"
            >
              <td className="px-3 py-2 text-content">{r.day}</td>
              <td className="px-3 py-2 text-content-secondary">{r.provider}</td>
              <td className="px-3 py-2 text-content-secondary">{r.model}</td>
              <td className="px-3 py-2 text-right text-content">{fmtInt(r.tokens.input)}</td>
              <td className="px-3 py-2 text-right text-content">{fmtInt(r.tokens.output)}</td>
              <td className="px-3 py-2 text-right text-content-secondary">{fmtInt(r.tokens.cache_read)}</td>
              <td className="px-3 py-2 text-right text-content-secondary">{fmtInt(r.tokens.cache_write)}</td>
              <td className="px-3 py-2 text-right text-content-secondary">{fmtInt(r.callCount)}</td>
              <td className="px-3 py-2 text-right text-content font-medium">{fmtCost(r.cost_micros)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
